export default __webpack_public_path__ + "static/feature-importances-dd5d72e7e1d7a502aec492758bd2932f.png";